<template>
    <hmenu></hmenu>

          <main>
            <section class="breadcrumb-height ns-breadcrumb-area" style="min-height: 300px; background-image: url('/assets/img/breadcrumb/breadcrumb-bg.jpg');" >
                <img src="/assets/img/breadcrumb/shape-1.png" alt="" class="ns-breadcrumb-shape-1">
                <img src="/assets/img/breadcrumb/breadcrumb-map.png" alt="" class="ns-breadcrumb-map">
                <img src="/assets/img/breadcrumb/shape-2.png" alt="" class="ns-breadcrumb-shape-2">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="ns-breadcrumb-wrap text-center">
                                <h2 class="ns-breadcrumb-title">Sistem i Automatizuar i Parkimit</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>




            <div class="ns-project-details-area pt-50 pb-70">



            <div class="ns-custom-navbar" >
              <ul class="nav nav-pills " id="pills-tab" role="tablist"  style="background-color: #eff0f5;">
                  <li class="nav-item" role="presentation">
                    <button @click="tabClick('info')" class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Informatat bazike</button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button @click="tabClick('kioska')" class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Kioska per pagesa</button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button @click="tabClick('hyrja')" class="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Terminali i hyrjes</button>
                  </li> 
                  <li class="nav-item" role="presentation">
                    <button @click="tabClick('dalja')" class="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Terminali i daljes</button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button @click="tabClick('soft')" class="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Softueri Gparking</button>
                  </li>
              </ul>
            </div>




                <div class="container">
                    <div class="row" v-if="selected == 'info' ">
                    <div class="row">


                        <div class="col-12">
                          <h2 class="ns-breadcrumb-title">Zgjidhja Ideale për Parkimin e Automatizuar</h2>
                    
                            <p class="ns-project-details-text">Gpro është një kompani inovative e specializuar në sistemet e automatizuara të parkimit, duke ofruar një zgjidhje të plotë për parkimet e vogla dhe të mesme. <br> Me teknologjinë më të avancuar dhe një qasje të përqendruar te efikasiteti, Gpro mundëson një përvojë të lehtë dhe të sigurt për menaxhimin e hyrjeve dhe daljeve </p>
                     </div>

                     <div class="col-xl-6 col-lg-4 col-md-4">


                          <div class="ns-project-details-content mb-40">
                            <div class="ns-project-details-list">
                                <ul>
                                    <li><i class="icofont-tick-boxed"></i>Automatizim i Plotë</li>
                                    <li><i class="icofont-tick-boxed"></i>Hyrje dhe Dalje Inteligjente</li>
                                    <li><i class="icofont-tick-boxed"></i>Vetë-Pagesa e Thjeshtë</li>
                                    <li><i class="icofont-tick-boxed"></i>Monitorim dhe Kontroll në Kohë Reale</li>
                                    <li><i class="icofont-tick-boxed"></i>Efikasitet dhe Reduktim i Kostove</li>
                                </ul>
                              </div>
                              <br>
                              <div class="ns-project-details-list">
                                <h4>Si Funksionon?</h4>
                                <ul>
                                    <li><i class="icofont-tick-boxed"></i>HYRJA - Sistemi njeh targën e automjetit dhe hap barrieren automatikisht dhe lëshon një biletë hyrjeje.</li>
                                    <li><i class="icofont-tick-boxed"></i>PARKIMI - Automjeti parkohet në zonën e caktuar, ndërsa sistemi regjistron kohën e hyrjes.</li>
                                    <li><i class="icofont-tick-boxed"></i>PAGESA - Para largimit, përdoruesi mund të kryejë pagesën në kioskun e vetë-pagesës</li>
                                    <li><i class="icofont-tick-boxed"></i>DALJA - Pas konfirmimit të pagesës, barriera hapet automatikisht për një dalje të shpejtë dhe pa vonesa.</li>
                                </ul>
                            </div>
                          </div>
                        </div>



                        <div class="col-xl-6 col-lg-7 col-md-7">
                          <div class="ns-project-details-img-2 w_img mb-40">
                              <img src="/asetet/info.png" alt="">
                          </div>
                        </div>
                        </div>


                    </div>


                    <div class="row" v-if="selected == 'kioska' ">
                        <div class="col-xl-4 col-lg-5 col-md-5">
                            <div class="ns-project-details-img-2 w_img mb-40">
                                <img src="/asetet/kioska.png" alt="">
                            </div>
                        </div>
                        <div class="col-xl-8 col-lg-7 col-md-7">
                            <div class="ns-project-details-content mb-40">
                                <div class="ns-project-details-list kioska__">
                                    <h4>Kioska per vete pagesa</h4>

                                    <div>
                                      <ul class="para" style="flex-wrap: wrap;">
                                        <li><i class="icofont-tick-boxed"></i><strong>Dizajn Modern dhe Kompakt </strong>  
                                          <p>Përputhet me çdo ambient, duke ofruar një pamje estetike dhe funksionale.</p>
                                        </li>
                                        <li><i class="icofont-tick-boxed"></i><strong>Lehtësi në Përdorim </strong>  
                                          <p>Ndërfaqe intuitive me ekran me prekje për një navigim të thjeshtë dhe të kuptueshëm.</p>
                                        </li>    
                                        <li><i class="icofont-tick-boxed"></i><strong>Pagesa të Shumëfishta </strong>  
                                          <p>Pranon monedha metalike dhe kartëmonedha në madhësi të ndryshme për të ofruar fleksibilitet maksimal.</p>
                                        </li>
                                        <li><i class="icofont-tick-boxed"></i><strong>Siguri e Lartë </strong>  
                                          <p>Sisteme të integruara kundër mashtrimeve dhe bllokimeve për një proces të sigurt të pagesave.</p>
                                        </li>    
                                        <li><i class="icofont-tick-boxed"></i><strong>Mirëmbajtje e Lehtë </strong>  
                                          <p>Struktura modulare lejon akses të thjeshtë për servis dhe mirëmbajtje të rregullt.</p>
                                        </li>
                                      </ul>
                                      <br>
                                      <br>
                                      <h4>Si Funksionon?</h4>
                                      <ul>
                                          <li><p>1. Përdoruesi skanon tiken me QR kode ose skanon Kartelen tek vendi i përcaktuar Sistemi llogarit shumën për pages.</p></li>
                                          <li><p>2. Vendos monedhat metalike ose kartëmonedhat në hapësirat përkatëse të pagesës.</p></li>
                                          <li><p>3. Sistemi autorizon tiketën ose kartelen dhe nëse është e nevojshme, jep kusurin automatikisht.</p></li>
                                          <li><p>4. Përdoruesi merr faturën ose biletën e konfirmimit dhe përfundon procesin e pagesës pa ndihmën e stafit.</p></li>
                                      </ul>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>





                    <div class="row" v-if="selected == 'hyrja' ">

                      <div class="row">
                          <div class="col-xl-4 col-lg-5 col-md-5">
                              <div class="ns-project-details-img-2 w_img mb-40">
                                  <img src="/asetet/thyrjes1.png" alt="">
                              </div>
                          </div>


                          <div class="col-xl-8 col-lg-7 col-md-7">
                              <div class="ns-project-details-content mb-40">
                                  <div class="ns-project-details-list hyrja__">
                                      <h4>Terminali i hyrjes</h4>
                                      <p class="ns-project-details-text">Terminali i hyrjes nga Gpro është një pajisje e avancuar dhe e besueshme për menaxhimin e hyrjeve në hapësira të ndryshme si parkingjet, qendrat tregtare dhe objektet publike. Me një dizajn modern dhe një strukturë të ndërtuar për të qenë rezistente ndaj kushteve atmosferike, ky terminal ofron një përvojë të sigurt dhe të lehtë për përdoruesit. </p>
                                      <div>
                                        <h4>Karakteristikat Kryesore</h4>
                                        <ul class="para">
                                          <li><i class="icofont-tick-boxed"></i><strong>Skanim i Kartelave </strong>  
                                            <p>Mbështet abonimet mujore dhe vjetore duke ofruar një proces të shpejtë dhe të automatizuar për hyrjen.</p>
                                          </li>
                                          <li><i class="icofont-tick-boxed"></i><strong>Buton për Marrjen e Tiketës/Kartelës </strong>  
                                            <p>Përdoruesit mund të marrin lehtësisht një tiketë ose kartelë me një shtypje të thjeshtë.</p>
                                          </li>  
                                          <li><i class="icofont-tick-boxed"></i><strong>Dizajn Modern për cdo ambient </strong>  
                                            <p>Dizajn Estetikisht i këndshëm dhe i përshtatshëm për çdo ambient.</p>
                                          </li>

                                         
                                          <li><i class="icofont-tick-boxed"></i><strong>Rezistencë ndaj Kushteve të Motit </strong>  
                                            <p>I ndërtuar për të përballuar ndryshimet klimatike, duke garantuar</p>
                                          </li>    
                                          <li><i class="icofont-tick-boxed"></i><strong>Integrim i Lehtë </strong>  
                                            <p>Mund të lidhet me sistemet ekzistuese të parkimit dhe automatizimit për një funksionim të plotë.</p>
                                          </li>
                                        </ul>
                                    
                              
                                      </div>
                                  </div>
                              </div>
                          </div>
                        </div>


                      <div class="row">
                          <div class="col-xl-8 col-lg-7 col-md-7">
                            <h4>Si Funksionon?</h4>
                            <ul>
                                <li><p>1. Përdoruesi skanon kartelën për hyrje nëse është abonent mujor ose vjetor.</p></li>
                                <li><p>2. Nëse nuk ka abonim, përdoruesi shtyp butonin për të marrë një tiketë ose kartelë hyrjeje.</p></li>
                                <li><p>3. Sistemi regjistron hyrjen dhe hap barrierën automatikisht.</p></li>
                                <li><p>4. Të dhënat ruhen në sistem për menaxhim dhe monitorim të mëtejshëm.</p></li>
                            </ul>
                            <br>
                            <br>
                            <h4>Zgjidhja Perfekte për Kontroll të Automatizuar të Hyrjeve</h4>
                            <p class="ns-project-details-text">Me terminalin e hyrjes nga Gpro, bizneset dhe institucionet mund të menaxhojnë fluksin e hyrjeve në mënyrë të automatizuar, duke ofruar siguri dhe efiçiencë maksimale.</p>
                        </div>
                         <div class="col-xl-4 col-lg-5 col-md-5">
                              <div class="ns-project-details-img-2 w_img mb-40">
                                  <img src="/asetet/thyrjes.png" alt="">
                              </div>
                          </div>
                      </div>
                    </div>


                    <div class="row"  v-if="selected == 'dalja' ">
                        <div class="col-xl-4 col-lg-5 col-md-5">
                            <div class="ns-project-details-img-2 w_img mb-40">
                                <img src="/asetet/tdaljes.png" alt="">
                            </div>
                        </div>
                        <div class="col-xl-8 col-lg-7 col-md-7">
                            <div class="ns-project-details-content mb-40">
                                <div class="ns-project-details-list hyrja__">
                                    <h4>Terminali i daljes</h4>
                                    <p class="ns-project-details-text">Terminali i daljes nga Gpro është një pajisje inovative që ofron një proces të shpejtë dhe të sigurt për daljen nga parkingu. Me një dizajn modern dhe një ndërtim rezistent ndaj kushteve atmosferike, ky terminal është i përshtatshëm për përdorim në çdo mjedis. </p>
                                    <div>
                                      <h4>Karakteristikat Kryesore</h4>
                                      <ul class="para">
                                        <li><i class="icofont-tick-boxed"></i><strong>Skanim i Biletave me QR Kod </strong> 
                                          <p>Lejon daljen nga parkingu duke skanuar biletën me QR kod për dalje të shpejtë</p>
                                        </li>
                                        <li><i class="icofont-tick-boxed"></i><strong>Skanim i Kartelave  </strong>  
                                          <p>Mbështet abonentët mujorë dhe vjetorë ose për periudha te paracaktuara për dalje të shpejtë.</p>
                                        </li>    
                                        <li><i class="icofont-tick-boxed"></i><strong>Dizajn Modern </strong> 
                                          <p>Integron teknologji të avancuar dhe një pamje estetike të përshtatshme për çdo ambient.</p>
                                        </li>
                                        <li><i class="icofont-tick-boxed"></i><strong>Rezistencë ndaj Kushteve të Motit </strong>  
                                          <p>I ndërtuar për të përballuar ndryshimet klimatike dhe për të siguruar funksionim të qëndrueshëm.</p>
                                        </li>    
                                        <li><i class="icofont-tick-boxed"></i><strong>Integrim i Plotë </strong> 
                                          <p>Mund të lidhet me sistemet ekzistuese të parkimit për një përvojë të pandërprerë.</p>
                                        </li>
                                      </ul>
                                      <br>
                                      <br>
                                      <h4>Si Funksionon?</h4>
                                      <ul>
                                          <li><p>1. Përdoruesi skanon biletën me QR kod për të autorizuar daljen.</p></li>
                                          <li><p>2. Abonentët mujorë ose vjetorë mund të skanojnë kartelën e tyre për dalje automatike.</p></li>
                                          <li><p>3. Sistemi verifikon pagesën dhe hap barrierën në mënyrë të menjëhershme.</p></li>
                                          <li><p>4. Të dhënat ruhen në sistem për menaxhim dhe monitorim të mëtejshëm.</p></li>
                                      </ul>
                                      <br>
                                      <br>
                                      <h4>Zgjidhja Ideale për Dalje të Automatizuar</h4>
                                      <p class="ns-project-details-text">Terminali i daljes nga Gpro është një zgjedhje e shkëlqyer për bizneset dhe institucionet që kërkojnë një menaxhim efikas të daljes nga parkingu.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row"  v-if="selected == 'soft' ">

                        <div class="col-xl-8 col-lg-7 col-md-7">
                            <div class="ns-project-details-content mb-40">
                                <div class="ns-project-details-list hyrja__">
                                    <h4>GParking – Softueri i Avancuar për Menaxhimin e Parkimit</h4>
                                    <p class="ns-project-details-text">GParking është një zgjidhje e plotë dhe e automatizuar për menaxhimin e parkingjeve, e projektuar për të lehtësuar dhe optimizuar proceset kryesore të administrimit. Me funksionalitete të avancuara dhe një ndërfaqe intuitive, GParking mund të përdoret lehtësisht si nga kompjuteri ashtu edhe nga telefoni mobil. </p>
                                    <div>
                                      <h4>Karakteristikat Kryesore</h4>
                                      <ul class="para">
                                        <li><i class="icofont-tick-boxed"></i><strong>Pagesa me QR Kod ose RF Kartela </strong> 
                                          <p>Përdoruesit mund të kryejnë pagesat shpejt dhe sigurt përmes skanimit të një QR kodi ose duke përdorur kartelat RFID.</p>
                                        </li>
                                        <li><i class="icofont-tick-boxed"></i><strong>Vazhdimi i Abonimeve </strong> 
                                          <p>Lehtëson rinovimin e abonimeve mujore dhe vjetore për përdoruesit ekzistues.</p>
                                        </li>    
                                        <li><i class="icofont-tick-boxed"></i><strong>Regjistrimi i Abonentëve të Rinj </strong> 
                                          <p>Regjistrimi dhe menaxhimi i abonimeve të reja bëhet thjesht dhe shpejt.</p>
                                        </li>
                                        <li><i class="icofont-tick-boxed"></i><strong>Menaxhimi i Çmimeve </strong> 
                                          <p>Administrimi fleksibil i tarifave të parkimit në bazë të orëve, ditëve ose llojeve të abonimeve.</p>
                                        </li>    
                                        <li><i class="icofont-tick-boxed"></i><strong>Regjistrimi i Stafit </strong> 
                                          <p>Mundëson krijimin dhe menaxhimin e llogarive të stafit për operacione të ndryshme.</p>
                                        </li> 
                                        <li><i class="icofont-tick-boxed"></i><strong>Raporte të Detajuara mbi të Hyrat </strong> 
                                          <p>Gjeneron raporte të sakta mbi të hyrat nga pagesat e parkimit.</p>
                                        </li>
                                        <li><i class="icofont-tick-boxed"></i><strong>Raporte mbi Hyrjet dhe Daljet </strong> 
                                          <p>Përfshin detaje mbi hyrjet dhe daljet e automjeteve, duke ruajtur edhe imazhet për çdo hyrje/dalje.</p>
                                        </li>
                                        <li><i class="icofont-tick-boxed"></i><strong>Menaxhimi i të Hollave në Kioskun e Vetë-Pagesave </strong> 
                                          <p>Monitorimi dhe raportimi i saktë i shumës së parave të pranuara në kioskën e vetë pagesave.</p>
                                        </li>
                                        <li><i class="icofont-tick-boxed"></i><strong>Qasje përmes Telefonit Mobil </strong> 
                                          <p>Të gjitha funksionalitetet e GParking mund të përdoren edhe nga një pajisje mobile, duke e bërë menaxhimin më të thjeshtë dhe më të përshtatshëm.</p>
                                        </li>
                                      </ul>
                                      
                                      <br>
                                      <br>

                                      <h4>Zgjidhja Perfekte për Menaxhimin e Parkimit</h4>
                                      <p class="ns-project-details-text">Me GParking, administrimi i parkimit bëhet më i shpejtë, më i sigurt dhe më efikas. Ky softuer modern ofron një qasje të plotë dhe të personalizuar për bizneset dhe institucionet që kërkojnë një sistem të automatizuar dhe të lehtë për përdorim.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-5 col-md-5">
                            <h5>Versioni Mobil</h5>
                            <div class="ns-project-details-img-2 w_img mb-40">
                                <img src="/asetet/mob.jpg" alt="">
                            </div>
                        </div>


                         <div class="col-12">
                          <h5>Versioni Desktop</h5>
                            <div class="ns-project-details-img-2 w_img mb-40">
                                <img src="/asetet/gparking.png" alt="">
                            </div>
                        </div>


                    </div>









                </div>
            </div>


        </main>


    <Footer></Footer>
</template>

<script>
    import hmenu from './header.vue'
    import Footer from './Footer.vue'

    export default {

        data () {
            return {
               selected:'info'
            }
        },


        methods:{

            tabClick(type){
              this.selected = type
            }

        },

        mounted:function(){

        },


        components: {
            hmenu,
            Footer,
         
        },


        mounted:function(){
            window.scrollTo({top: 0, behavior: 'smooth'});
        }


    }

</script>



<style>


  .ns-project-details-listt ul li {
      display: flex;
      align-items: center;
      line-height: 1;
      margin-bottom: 20px;
      gap: 5px;
      font-size: 17px;
      color: var(--clr-body-text);
  }



  .kioska__ ul li{
    line-height: 1!important;
    margin-bottom: 0px!important;
    gap: 5px!important;
  }


  .hyrja__ ul li{
    line-height: 1!important;
    margin-bottom: 0px!important;
    gap: 5px!important;
  }

  .para li{
    flex-wrap: wrap!important;
  }

</style>